import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { TableScrollTop } from '../../directives/table-scroll-top';

@Component({
  selector: 'app-employee-privacy-notice',
  imports: [RouterLink, TableScrollTop],
  templateUrl: './employee-privacy-notice.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './employee-privacy-notice.scss',
})
export class EmployeePrivacyNotice {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Employee Privacy Notice';
  protected readonly seoDescription =
    'How MARI collects, processes, transfers, shares, and retains the personal data of its employees worldwide, and the rights and choices available to them.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Privacy', path: '/privacy' },
        { name: 'Employee Privacy Notice', path: '/employee-privacy-notice' },
      ],
    });
  }
}
